export class CreateNewsletterTemplateModel {
    name: string;
    htmlContent: string;
    cssContent: string;
    templateContent: string;
    projectData : string;
}